import { useFormik } from 'formik';
import * as Yup from 'yup';

interface UseGoodsRequestFormikProps {
  onSubmit: (values: any, paginationConfig: any) => void;
}

export const goodGestorUpdateValidatorSchema = Yup.object({
  status_element_id: Yup.string().required('Estado del elemento es Requerido'),
  optionGestor: Yup.string(),

  quantity_received: Yup.number().when('optionGestor', {
    is: "All",
    then: (schema) => schema.min(1, 'Cantidad debe ser mayor a 0').required('Cantidad es Requerido'),
    otherwise: (schema) => schema.nullable(),
  }),

  observations: Yup.string().nullable(),
  ids: Yup.array().of(Yup.number()),
});
export const useGoodGestorUpdateValidator = ({
  onSubmit,
}: UseGoodsRequestFormikProps) => {
  return useFormik({
    initialValues: {
      items: [],
      observations: '',
      reason: '',
    },
    validationSchema: goodGestorUpdateValidatorSchema,
    onSubmit,
  });
};
//Status id
export const goodGestorStatusolicitud = Yup.object({
  status_id: Yup.string().required('Estado de la solicitud es Requerido'),
  reason: Yup.string().required('El motivo es Requerido'),
  approved_by: Yup.string().required('Aprobado por es Requerido'),
});
export const useGoodGestorStatusolicitud = ({
  onSubmit,
}: UseGoodsRequestFormikProps) => {
  return useFormik({
    initialValues: {
      status_id: '',
      reason: '',
      approved_by: 0,
    },
    validationSchema: goodGestorStatusolicitud,
    onSubmit,
  });
};
export const useAssetsAdvanceFilters = ({
  onSubmit,
}: UseGoodsRequestFormikProps) => {
  return useFormik({
    initialValues: {
    },
    onSubmit,
  });
};
export const goodGestorItems = Yup.object({
  quantity_received: Yup.number().min(0, 'No se permiten números negativos').nullable().notRequired()
});
export const useGoodGestorItems = ({
  onSubmit,
}: UseGoodsRequestFormikProps) => {
  return useFormik({
    initialValues: {
      items: [],
      quantity_received: null,
      location_id: null,
      status_id: null,
      observations: null,
      reason: '',
    },
    validationSchema: goodGestorItems,
    onSubmit,
  });
};